import React from "react";

const Sparkle: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Sparkle">
        <path
          id="Vector"
          d="M33.2118 27.1633C24.2483 25.1392 22.8599 23.7508 20.8358 14.7873C20.7431 14.3777 20.3784 14.0859 19.957 14.0859C19.5356 14.0859 19.171 14.3777 19.0782 14.7873C17.0533 23.7508 15.6657 25.1392 6.70231 27.1633C6.29173 27.2569 6 27.6207 6 28.0421C6 28.4635 6.29173 28.8272 6.70231 28.9209C15.6657 30.9458 17.0533 32.3343 19.0782 41.2968C19.171 41.7065 19.5356 41.9982 19.957 41.9982C20.3784 41.9982 20.7431 41.7065 20.8358 41.2968C22.8608 32.3343 24.2483 30.9458 33.2118 28.9209C33.6223 28.8272 33.9132 28.4635 33.9132 28.0421C33.9132 27.6207 33.6214 27.2569 33.2118 27.1633Z"
          fill="#77D286"
        />
        <path
          id="Vector_2"
          d="M41.3137 13.2104C36.5488 12.1344 35.8799 11.4654 34.8039 6.70141C34.7102 6.29083 34.3465 6 33.9251 6C33.5037 6 33.1399 6.29083 33.0463 6.70141C31.9703 11.4654 31.3013 12.1344 26.5373 13.2104C26.1268 13.304 25.8359 13.6678 25.8359 14.0892C25.8359 14.5105 26.1268 14.8743 26.5373 14.9679C31.3013 16.0439 31.9703 16.7129 33.0463 21.4778C33.1399 21.8875 33.5037 22.1792 33.9251 22.1792C34.3465 22.1792 34.7102 21.8875 34.8039 21.4778C35.8799 16.7129 36.5488 16.0439 41.3137 14.9679C41.7234 14.8743 42.0151 14.5105 42.0151 14.0892C42.0151 13.6678 41.7234 13.304 41.3137 13.2104Z"
          fill="#77D286"
        />
      </g>
    </svg>
  );
};

export default Sparkle;
